'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 2098
// module chunks = 0